module.exports = __webpack_public_path__ + "img/middle_13.70b9951a.png";